import { ROLES } from 'app/configs/roles';

/**
 * Get the current active role from localStorage
 * @returns The current role or empty string if not found
 */
export const getCurrentRole = (): string => {
  try {
    return localStorage.getItem('currentRole') || '';
  } catch (error) {
    console.error('Error getting current role:', error);
    return '';
  }
};

/**
 * Set the current active role in localStorage
 * @param role The role to set as current
 */
export const setCurrentRole = (role: string): void => {
  try {
    localStorage.setItem('currentRole', role);
  } catch (error) {
    console.error('Error setting current role:', error);
  }
};

/**
 * Remove the current role from localStorage
 */
export const removeCurrentRole = (): void => {
  try {
    localStorage.removeItem('currentRole');
  } catch (error) {
    console.error('Error removing current role:', error);
  }
};

/**
 * Get the default role based on user profiles
 * @returns The primary role from the first profile or '' if no profiles
 */
export const getDefaultRole = (): string => {
  try {
    const profiles = localStorage.getItem('profiles');
    if (profiles) {
      const parsedProfiles = JSON.parse(profiles);
      return parsedProfiles.length > 0 ? parsedProfiles[0].role : '';
    }
    return '';
  } catch (error) {
    console.error('Error getting default role:', error);
    return '';
  }
};

/**
 * Initialize the current role with the default role if not already set
 * Defaults to 'Agent' for existing users who won't login again
 */
export const initializeCurrentRole = (): void => {
  try {
    const currentRole = getCurrentRole();
    if (!currentRole) {
      const defaultRole = getDefaultRole();
      if (defaultRole) {
        setCurrentRole(defaultRole);
      } else {
        // Default to 'Agent' for existing users who won't login again
        setCurrentRole(ROLES.AGENT);
      }
    }
  } catch (error) {
    console.error('Error initializing current role:', error);
    // Fallback to 'Agent' if there's any error
    try {
      setCurrentRole(ROLES.AGENT);
    } catch (fallbackError) {
      console.error('Error setting fallback role:', fallbackError);
    }
  }
};
